export default __webpack_public_path__ + "static/media/indivisuals-mask.aa2539e6.svg";